'use client'

import { removeStored } from '@/utils/removeStored'
import { anonymize } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { selectedMutations } from '@mercadoni/sinister/dist/cjs/shared/services'
import uuid from './../../../utils/uuid'

const handleLogout = async () => {
  anonymize(uuid())
  // TODO: logout message
  removeStored([
    'instructions',
    'lastSuggestionTime',
    'selectedOpsModel',
    'selectedAddress',
    'selectedStore', // legacy
    'selectedAlphaStore', // legacy
    'storeReference',
    'selectedStoreId',
    'storeFilter',
    'token',
    'configs',
    'guestAddress',
    'customer',
    'noFed',
    'cartId',
    'cart',
    'cartState',
    'storeId',
    'logged',
  ])
  await selectedMutations.logOut() // Apollo logOut
  return true
}

export default handleLogout
